import React from "react";
import Modal from "../../overlay/Modal/Modal";
import { Button } from "../../controls/Button/Button";
 // (später am besten auch umbenennen zu Button)

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  onClose: () => void;
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
};

export const SuccessDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  title,
  onClose,
  secondaryAction,
}) => {
  const handleClose = () => {
    onOpenChange(false);
    onClose();
  };

  return (
    <Modal
      empty
      show={open}
      setShow={onOpenChange}
      className={`flex w-[500px] flex-col items-center justify-center gap-4 ${secondaryAction ? "h-[290px]" : "h-[250px]"}`}
    >
      <svg
        width="65"
        height="64"
        viewBox="0 0 65 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect x="0.5" width="64" height="64" rx="32" fill="#61C478" />
        <path
          d="M25.1133 40.8199L17.6572 33.3691C17.2554 32.9676 16.7105 32.7421 16.1423 32.7421C15.5742 32.7421 15.0292 32.9676 14.6275 33.3691C14.2257 33.7706 14 34.3151 14 34.8829C14 35.164 14.0554 35.4424 14.1631 35.7021C14.2707 35.9619 14.4285 36.1979 14.6275 36.3967L23.6092 45.3719C24.4472 46.2094 25.8009 46.2094 26.6389 45.3719L49.3725 22.6546C49.7743 22.2531 50 21.7086 50 21.1408C50 20.573 49.7743 20.0285 49.3725 19.627C48.9708 19.2255 48.4258 19 47.8577 19C47.2895 19 46.7446 19.2255 46.3428 19.627L25.1133 40.8199Z"
          fill="white"
        />
      </svg>

      <div className="popUpTitle text-center">{title}</div>

      <div className="flex flex-col items-center gap-2 w-full px-8">
        {secondaryAction && (
          <Button
            onClick={secondaryAction.onClick}
            className="h-[50px] w-full rounded-[30px] bg-[#F97316] font-bold"
          >
            {secondaryAction.label}
          </Button>
        )}
        <Button
          onClick={handleClose}
          className="h-[50px] w-[130px] rounded-[30px] bg-[#716D6B] font-bold"
        >
          Schließen
        </Button>
      </div>
    </Modal>
  );
};

export default SuccessDialog;